<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules">
      <FormItem
        v-for="(c, i) in formCtrl"
        :key="'formItem' + i"
        :viewMode="viewMode"
        :config="c"
        :options="c.options"
        :inputValue="form[c.keyName]"
        @onChange="onChange"
      />
      <div class="btns">
        <el-button type="primary" @click="onSubmit">保 存</el-button>
        <el-button>取 消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: "cartarget",
      breadcrumb: [{ name: "系统设置" }, { name: "车辆运费指标" }],
      form: { newtarget: undefined },
      rules: {
        newtarget: [
          {
            required: true,
            message: "请填写月度目标运费总额",
            trigger: "blur",
          },
        ],
      },
      formCtrl: [
        {
          label: "车辆月度目标运费总额",
          keyName: "newtarget",
          err: "请填写月度目标运费总额",
          tips:
            "该处设置车辆月度目标运费总额，可以在运营分析处查看车辆运费目标的实时完成情况。",
          type: "number",
        },
        // {
        //   label: "旧车月目标运费",
        //   keyName: "oldtarget",
        //   err: "请填写旧车月目标运费",
        //   type: "number",
        // },
      ],
    };
  },
  methods: {
    getData() {
      this.loading = true;
      let url = `${this.baseUrl}/index`;
      const params = {
        userid: this.user.id,
      };
      this.post(
        url,
        params,
        ({ msg, data }) => {
          if (msg === "success" && data) {
            this.detail = data;
            this.formCtrl.map((v) => {
              const key = v.keyName;
              this.form[key] = this.detail[key];
            });
            this.$forceUpdate();
            // console.log({ ...this.detail })
            // console.log({ ...this.form })
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    submitReq() {
      this.loading = true;
      let url = `${this.baseUrl}/edittarget`;
      const params = {
        userid: this.user.id,
      };
      const object = this.form;
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          params[key] = object[key];
        }
      }
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.getData();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding: 54px 0 44px 74px;
  border-radius: 5px;

  .el-form-item {
    .el-input {
      width: 300px;
    }
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
}

/deep/ .el-form-item__content {
  .content {
    display: block;

    .el-upload__tip {
      position: static;
      width: 300px;
      line-height: 22px;
      margin: 22px 0 0 0;
    }
  }
}

/deep/ .el-form .item .tips {
  width: 300px;
  line-height: 22px;
  margin: 22px 0 0 0;
  font-size: 12px;
}

.btns {
  margin: 0 0 0px 180px;

  .el-button {
    padding: 12px 25px;
  }

  .el-button--default {
    color: #303133;
    border: 1px solid #f3f3f3;
    background-color: #f3f3f3;
  }
}
</style>
